"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapPlanQueryKapiV1ToPlanCX = void 0;
var date_fns_1 = require("date-fns");
var __generated__1 = require("../../../../shared/api/kapi/v1/__generated__");
var utils_1 = require("../../utils/utils");
var mapPlanQueryKapiV1ToPlanCX = function (_a) {
    var account = _a.account;
    return !account
        ? null
        : __assign({}, account.contracts_nextV1.edges.reduce(function (acc, _a) {
            var _b;
            var contract = _a.node;
            if (!((_b = contract.supplyPoint.costProjection) === null || _b === void 0 ? void 0 : _b.cancelled) &&
                (0, utils_1.contractIsActiveAtNew)((0, date_fns_1.startOfToday)(), contract)) {
                acc[(0, utils_1.getContractFuelAsKey)(contract)].push(transformKapiContractToCXContract(contract));
            }
            return acc;
        }, { electricity: [], gas: [] }));
};
exports.mapPlanQueryKapiV1ToPlanCX = mapPlanQueryKapiV1ToPlanCX;
var mapProjectedConsumption = function (supplyPoint) {
    var _a, _b, _c;
    var msn = ((_a = supplyPoint.meterTechnicalDetails[0]) === null || _a === void 0 ? void 0 : _a.meterSerialNumber) || '';
    var totalConsumption = (_b = supplyPoint.costProjection) === null || _b === void 0 ? void 0 : _b.personalProjection.projectedRegisterConsumption.reduce(function (sum, el) { return (sum += Number(el.projectedConsumption)); }, 0);
    return [
        {
            msn: msn,
            consumption: (_c = totalConsumption === null || totalConsumption === void 0 ? void 0 : totalConsumption.toString()) !== null && _c !== void 0 ? _c : '',
        },
    ];
};
function transformKapiContractToCXContract(_a) {
    var _b, _c;
    var tariffs = _a.tariffs, supplyPoint = _a.supplyPoint;
    var mapUnitRate = ((_c = (_b = tariffs[0].tariff_nextV1.consumptionChargeRates) === null || _b === void 0 ? void 0 : _b.ratesByTimingCategory) === null || _c === void 0 ? void 0 : _c.map(function (unitRate) {
        return {
            defaultRate: unitRate.defaultRate,
            defaultRateLabel: unitRate.defaultRateLabel,
            blockRates: [],
            timingCategory: mapKaPITimingCategoryToCXTimingCategory(unitRate.timingCategory),
        };
    })) || [];
    return {
        //Using first tariff for now
        name: tariffs[0].tariff_nextV1.name,
        unitRates: mapUnitRate,
        standingCharge: tariffs[0].tariff_nextV1.standingRate,
        contractStartDate: tariffs[0].startDate,
        contractEndDate: tariffs[0].endDate || null,
        contractType: tariffs[0].tariff_nextV1.type,
        exitFee: tariffs[0].tariff_nextV1.exitFee,
        mpxn: supplyPoint.sprn,
        msn: supplyPoint.meterTechnicalDetails.map(function (info) { return info.meterSerialNumber; }) ||
            [],
        projectedConsumption: mapProjectedConsumption(supplyPoint) || [],
        // TODO: these two fields are no longer computed, however we will need them in the future when we have a need to show the customer their exit fees. Defining as undefined for transparency
        isInRenewal: undefined,
        hasFutureContracts: undefined,
    };
}
function mapKaPITimingCategoryToCXTimingCategory(timingCategory) {
    switch (timingCategory) {
        case 'HEATING':
            return __generated__1.SupplyPointTimingCategory.Heating;
        case 'EVENING_AND_WEEKEND':
            return __generated__1.SupplyPointTimingCategory.EveningAndWeekend;
        case 'OFFPEAK':
            return __generated__1.SupplyPointTimingCategory.OffPeak;
        case 'PEAK':
            return __generated__1.SupplyPointTimingCategory.Peak;
        case 'ANYTIME':
            return __generated__1.SupplyPointTimingCategory.Anytime;
        default:
            return null;
    }
}
